// extracted by mini-css-extract-plugin
module.exports = {"usedVehicles":"_a3","usedVehiclesTitle":"_a4","usedVehiclesContainer":"_a5","usedVehiclesItem":"_a6","usedVehiclesButton":"_a7"};